import { useEffect } from "react";
import {
  MapPinIcon,
  AtSymbolIcon,
  CalendarIcon,
  AcademicCapIcon,
  BriefcaseIcon,
} from "@heroicons/react/20/solid";
import AOS from "aos";
import "aos/dist/aos.css";
import profileImage from '../PROFILE.png'
const features = [
  {
    name: "Age:",
    description: "23 years old",
    icon: CalendarIcon,
  },
  {
    name: "Email:",
    description: "niyatinehal67@gmail.com",
    icon: AtSymbolIcon,
  },
  {
    name: "Location:",
    description: "Bengaluru, India",
    icon: MapPinIcon,
  },
];

export default function About() {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <div
      className="relative isolate overflow-hidden  px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0"
      id="about"
    >
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <h2 className="text-lg leading-7">Get to know more</h2>
              <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl">
                About Me
              </p>
              <p className="mt-6 text-lg leading-8" data-aos="fade-right">
                Hello, I'm Niyati Nehal, a driven Software Developer based in India. With a profound commitment to fostering technical education, I specialize in crafting immersive learning experiences that emphasize hands-on application development. My journey in software development is not just about writing code; it's about inspiring and empowering others to embark on their own technological adventures.Drawing from my extensive experience, I've honed my skills in designing interactive learning modules and engaging workshops that cater to diverse audiences. Whether it's diving into the intricacies of programming languages or exploring cutting-edge technologies, I'm dedicated to cultivating an environment where individuals can thrive and grow their expertise. Beyond my role as a developer, I see myself as a facilitator of knowledge, guiding aspiring technologists on their path to success.
              </p>
            </div>
          </div>
        </div>
        <div
          className="-ml-12 -mt-12 p-12 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden"
          data-aos="fade-left"
        >
          <img
            className="w-[25 rem] h-[40.75rem] ring-2 ring-base-300 max-w-none rounded-xl shadow-xl sm:w-[25rem]"
            src={profileImage}
            alt="Person"
          />
        </div>
      </div>
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
        <div className="lg:col-span-2 lg:col-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="text-base leading-7">
            <div className="grid gap-x-6 sm:grid-cols-2">
              <div
                className="ring-2 ring-base-300 bg-base-200 rounded-2xl mt-10 p-5 shadow-xl"
                data-aos="zoom-in"
              >
                <BriefcaseIcon className="h-5 w-5 mx-auto" aria-hidden="true" />
                <h2 className=" text-2xl text-center font-bold tracking-tight">
                  Experience
                </h2>
                <p className="mt-3 list-item list-inside">
                  Computer Science graduate with expertise in Frontend.
                </p>
                <p className="mt-3 list-item list-inside">
                  Diverse experience in web development.
                </p>
                <p className="mt-3 list-item list-inside">
                  Mentors aspiring developers.
                </p>
              </div>
              <div
                className="ring-2 ring-base-300 bg-base-200 rounded-2xl mt-10 p-5 shadow-xl"
                data-aos="zoom-in"
              >
                <AcademicCapIcon
                  className="h-5 w-5 mx-auto"
                  aria-hidden="true"
                />
                <h2 className=" text-2xl text-center font-bold tracking-tigh">
                  Education
                </h2>
                <p className="mt-3 list-item list-inside">
                K-verse Social Media: Developed web apps with HTML, CSS, and JavaScript.
                </p>
                <p className="mt-3 list-item list-inside">
                Bookshala E-commerce website: Contributed to MERN stack project.
                </p>
                <p className="mt-3 list-item list-inside">
                  Minion talks: A fun website that lets you talk like minions made with react and api integration.
                </p>
              </div>
            </div>
            <dl
              className="mt-10 space-y-8 text-base leading-7 lg:max-w-none"
              data-aos="fade-right"
            >
              {features.map((feature) => (
                <div key={feature.name} className="relative pl-9">
                  <dt className="inline font-semibold">
                    <feature.icon
                      className="absolute left-1 top-1 h-5 w-5"
                      aria-hidden="true"
                    />
                    {feature.name}
                  </dt>{" "}
                  <dd className="inline">{feature.description}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}